/**
 * Module Pennylane — bible §2.5 (VALIDÉ) : en V1 un accès de navigation
 * (ouverture onglet), l'intégration API arrive en V2.1. Écart E8 résorbé.
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "pennylane",
  label: "Pennylane",
  icon: "i-wallet",
  navGroup: "finance",
  navOrder: 30,
  rolesRequis: ["admin", "secretariat", "comptabilite"],
  routes: [{ path: "/pennylane", component: lazy(() => import("./routes/Index")) }],
};

export default mod;
